import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowseSurveyComponent } from './browse-survey.component';

const routes: Routes = [
  {path:"",component:BrowseSurveyComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrowseSurveyRoutingModule { }
